// The reviver's third argument, `context.source`, is the raw JSON text for
// the current value; the polyfill supplies it on browsers that lack it.
import "core-js/actual/json/parse";

/**
 * The keys of a value count (`GET v1/query/id/{id}/value-counts`) whose
 * integers can run past `Number.MAX_SAFE_INTEGER`: a counted `value`, such as
 * a session's nanosecond `min_timestamp_ns`, and the nanosecond `first_time`
 * and `last_time` of the records holding it.
 */
const VALUE_COUNT_INTEGER_KEYS = new Set<string>([
  "value",
  "first_time",
  "last_time",
]);

/**
 * `JSON.parse` reviver that returns a `bigint` for an integer token under a
 * key in `VALUE_COUNT_INTEGER_KEYS`, re-read from the raw token text in
 * `context.source` so no digit is lost. A float or exponent literal, a
 * string, a boolean, `null`, and any value under another key come back as
 * the default parse produced them.
 */
export function parseValueCountIntegersAsBigInt(
  key: string,
  value: unknown,
  context?: { source: string },
) {
  if (
    VALUE_COUNT_INTEGER_KEYS.has(key) &&
    typeof value === "number" &&
    context !== undefined &&
    /^-?\d+$/.test(context.source)
  ) {
    return BigInt(context.source);
  }
  return value;
}
